import Icon from "assets/images/settings/passwordNew.svg";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import styled from "styled-components";
import { object, string } from "yup";
import * as Yup from "yup";
import { Button, TextView } from "../../components";
import { toast } from "react-toastify";
import { colors } from "../../utils";
import Input from "../Input";
import { useForgotSendEmailOtp, useVerifyPassword } from "../../services/mutations";
import OTPModal from "../PasswordAlert";
import { OTPContent } from "./Password/otpContent";
import { ChangePasswordContent } from "./Password/changePassword";
import { useSelector } from 'react-redux';
import OtpIcon from "assets/images/settings/otp.svg";
import PasswordIcon from "assets/images/settings/secure.svg";

const CenterWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  padding: 3vw;
`;

const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

const PasswordTitle = styled.div`
  display: flex;
  flex-direction: column;
`

const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

const Content = styled.div`
  margin-top: 20px;
`;

const Error = styled(TextView)`
  color: ${colors.error};
  position: absolute;
  margin-top: -24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;
`

const Item = styled.div``;

const passwordSchema = object({
  current_password: string().required("Current Password is required"),
});

export default function Password() {
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");

  const { userProfile } = useSelector((state) => state.userProfile);

  const sendEmailOtp = useForgotSendEmailOtp();
  const verifyUserPassword = useVerifyPassword();

  const closeOtpModal = () => {
    setShowOtpModal(false);
  };

  const closePasswordModal = () => {
    setChangePasswordModal(false);
  };

  const sendOtp = (values, { setSubmitting, resetForm }) => {
    try{
      verifyUserPassword.mutateAsync(
        {
          password: values.current_password
        },
        {
          onSuccess: () => {
            sendEmailOtp.mutate(
              {
                email: values.email_address
              },
              {
                onSuccess: (response) => {
                  setSubmitting(false);
                  resetForm()
                  toast.success("An otp has been sent to your email address!");
                  setShowOtpModal(true)
                },
                onError: (err) => {
                  console.log(err);
                  toast.error(err.response.data.message);
                  setSubmitting(false);
                },
              }
            )
          },
          onError: (err) => {
            setSubmitting(false);
            console.log("err", err);
            toast.error(err.response.data.message);
          }
        }
      )
    }
    catch(err){
      toast.error(err.response.data.message);
    }
  }

  return (
    <CenterWrapper>
      <ContentHeader>
        <HeaderIcon src={Icon} />
        <PasswordTitle>
          <TextView variant="title">Password</TextView>
          <TextView variant="subtitle">
            Change your password regularly to make your account safer
          </TextView>
        </PasswordTitle>
      </ContentHeader>
      <Content>
        <Formik
          initialValues={{
            email_address: userProfile.email,
            current_password: "",
          }}
          validationSchema={passwordSchema}
          onSubmit={sendOtp}
        >
          {({ isSubmitting, handleSubmit }) => (
            <Form onSubmit={handleSubmit} style={{ maxWidth: 450 }} autoComplete="off">
              
              <Item>
                <Field
                  name="email_address"
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="email"
                      label="Email Address"
                      placeholder="Email Address"
                      disabled={true}
                    />
                  )}
                />
              </Item>

              <Item>
                <Field
                  name="current_password"
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="password"
                      label="Current Password"
                      placeholder="Current Password"
                      onChange={(e) => {
                        setCurrentPassword(e.target.value);
                        field.onChange(e);
                      }}
                      autoComplete="new-password"
                      customBgColor="#fff"
                    />
                  )}
                />
                <ErrorMessage name="current_password">
                  {(msg) => <Error variant="tag">*{msg}</Error>}
                </ErrorMessage>
              </Item>

              <ButtonContainer>
                <Button
                  isLoading={isSubmitting}
                  type="submit"
                  style={{ width: 155 }}
                >
                  Change Password
                </Button>
              </ButtonContainer>
            </Form>
          )}
        </Formik>

        <OTPModal
          open={showOtpModal || changePasswordModal}
          handleClose={showOtpModal ? closeOtpModal : closePasswordModal}
          icon={showOtpModal ? OtpIcon : PasswordIcon}
          title={showOtpModal ? "OTP Verification" : "Change Password"}
        >
          {showOtpModal && (
            <OTPContent 
              onVerifySuccess={() => {
              closeOtpModal()
              setChangePasswordModal(true)
            }}
            />
          )}

          {changePasswordModal && (
            <ChangePasswordContent onCancel={() => setChangePasswordModal(false)} currentPassword={currentPassword} />
          )}
        </OTPModal>
      </Content>
    </CenterWrapper>
  );
}
